<script lang="ts">
  import { categoryStaticBottomContent } from '../../product-listing-search/store/plp-data-store';
</script>

<div class="yCmsContentSlot c_product-list--section1 row-flex c_seo-content bg-white">
  <div class="yCmsComponent yComponentWrapper component">
    <div class="c_category-details c_category-details-seo">
      <div class="c_category-details-title c_category-details-title__medium">
        {$categoryStaticBottomContent.heading}
      </div>
      <p>
        {@html $categoryStaticBottomContent.body}
      </p>
    </div>
  </div>
</div>

<style lang="scss">
  @import '../../../common/styles/vars.scss';
  :global {
    .c_category-details .c_category-details-title__medium {
      font-size: 2.4rem;
      font-weight: 600;
      margin: 0;
    }
    .c_category-details p {
      color: $color-alabaster-gray;
      font-size: 1.4rem;
      margin: 0.8rem 0 1.5rem;

      a {
        text-decoration: none;
      }
    }
  }
  .page-container,
  .category-page,
  .brand-page {
    .c_seo-content {
      max-width: 1440px;
      margin: 0 auto;
      .c_category-details-seo {
        margin: 0;
        padding: 1.5rem 3rem;
        @include desktop-min-width {
          max-width: 144rem;
          margin: auto;
          padding: 3rem 4rem;
        }
      }
      .c_category-details p {
        color: $color-alabaster-gray;
        font-size: 1.4rem;
        margin: 1.5rem 0 0rem;

        a {
          text-decoration: none;
        }
      }
    }
  }
</style>
